import { Outlet } from 'react-router-dom';
import BookmarkHeader from './BookmarkHeader';

const Bookmark = () => {

  return (
    <>
      <BookmarkHeader />
      <Outlet />
    </>

  );
};

export default Bookmark;
